<template>
  <div class="admin-page">
    <div class="admin-page-inner admin-page-inner--compact">
      <div class="admin-page-header">
        <div class="admin-page-heading">
          <button
            type="button"
            class="admin-button--secondary admin-button--sm"
            @click="$router.push({ name: 'AdminData' })"
          >
            <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Zurück
          </button>
          <div>
            <span class="admin-kicker">Datenverwaltung</span>
            <h1 class="admin-page-title">Equipment</h1>
          </div>
        </div>
      </div>
      <section class="admin-panel">
        <div class="admin-panel__body">
        <div v-if="loading" class="text-center py-8">Lade Equipment...</div>
        <div v-else class="pt-4">
          <table class="min-w-full table-auto border border-gray-300">
            <thead>
              <tr>
                <th class="px-4 py-2 border">Name</th>
                <th class="px-4 py-2 border">Aktionen</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="border px-4 py-2">
                  <input v-model="newEquipmentName" @keyup.enter="addEquipment" class="border px-2 py-1 w-full" placeholder="Neues Equipment" />
                </td>
                <td class="border px-4 py-2">
                  <button type="button" @click="addEquipment" :disabled="!newEquipmentName.trim()" class="admin-button--primary admin-button--sm disabled:opacity-50">Hinzufügen</button>
                </td>
              </tr>
              <tr v-for="(eq, idx) in equipment" :key="eq.id || eq.name">
                <template v-if="editingEquipmentIdx === idx">
                  <td class="border px-4 py-2">
                    <input v-model="editEquipmentName" @keyup.enter="saveEquipment(idx)" class="border px-2 py-1 w-full" />
                  </td>
                  <td class="border px-4 py-2">
                    <button type="button" @click="saveEquipment(idx)" class="admin-button--primary admin-button--sm mr-2">Speichern</button>
                    <button type="button" @click="cancelEditEquipment" class="admin-button--secondary admin-button--sm">Abbrechen</button>
                  </td>
                </template>
                <template v-else>
                  <td class="border px-4 py-2">{{ eq.name }}</td>
                  <td class="border px-4 py-2">
                    <button type="button" @click="editEquipment(idx)" class="admin-button--secondary admin-button--sm mr-2">Bearbeiten</button>
                    <button type="button" @click="deleteEquipment(idx)" class="admin-button--danger admin-button--sm mr-2">Löschen</button>
                  </td>
                </template>
              </tr>
              <tr v-if="!equipment || equipment.length === 0">
                <td colspan="2" class="text-gray-400 px-4 py-2">Keine Einträge</td>
              </tr>
            </tbody>
          </table>
        </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CASP from '@/CASP.js';

export default {
  data() {
    return {
      loading: true,
      equipment: [],
      newEquipmentName: '',
      editingEquipmentIdx: null,
      editEquipmentName: '',
    };
  },
  methods: {
    loadData() {
      CASP.getCoreData((status, result) => {
        if (status == 200) {
          this.equipment = result.equipment || [];
          this.loading = false;
        }
      });
    },
    addEquipment() {
      const name = this.newEquipmentName.trim();
      if (!name) return;
      CASP.addCoreData("equipment", { name }, (status, result) => {
        if (status == 200) {
          this.loadData();
          this.newEquipmentName = '';
        }
      });
    },
    editEquipment(idx) {
      this.editingEquipmentIdx = idx;
      this.editEquipmentName = this.equipment[idx].name;
    },
    saveEquipment(idx) {
      const name = this.editEquipmentName.trim();
      if (!name) return;
      CASP.updateCoreData("equipment", this.equipment[idx].id, { name }, (status, result) => {
        if (status == 200) {
          this.loadData();
          this.editingEquipmentIdx = null;
          this.editEquipmentName = '';
        }
      });
    },
    cancelEditEquipment() {
      this.editingEquipmentIdx = null;
      this.editEquipmentName = '';
    },
    deleteEquipment(idx) {
      if (confirm('Wirklich löschen?')) {
        CASP.deleteCoreData("equipment", this.equipment[idx].id, (status, result) => {
          if (status == 200) {
            this.loadData();
          }
        });
      }
    }
  },
  created() {
    this.loadData();
    document.getElementById("mainspinner").style.display = "none";
  }
};
</script>
